import styled, { keyframes } from "styled-components";
import { FaSpinner } from "react-icons/fa";
import { createStyledIcon } from "utils/iconUtils";

const SpinnerIcon = createStyledIcon(FaSpinner);

export const LoadingWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Spinner = styled(SpinnerIcon)`
  animation: ${spin} 1s linear infinite;
  font-size: 3rem;
  color: ${({ theme }) => theme.colors.primary};
`;
